import { AxiosPromise } from 'axios'
import client from './client'
import { RequestEventStatistics } from '../types/models/Dashboard'

export const getRequestEventStatistics =
  (): AxiosPromise<RequestEventStatistics> => {
    return client.get('/dashboard/request_event_statistics/')
  }
